<template>
<v-flex>
    <div class="text-xs-center" v-if="loading">
        <v-progress-circular
                :size="50"
                color="primary"
                indeterminate
        ></v-progress-circular>
    </div>
    <div v-else class="header-section">
        <week-list :season="this.season"></week-list>
    </div>
    <section v-if="!loading" class="elevation-1 week-score-cards" >
        <div v-sticky="stickyConfig" style="background:white" class="table-header-section">
            <h3 class="pa-3">{{season.name}} Week {{week}} Scores</h3>
            <v-data-table
                    ref="headerTable"
                    :headers="headers"
                    :items="[]"
                    hide-actions
                    disable-initial-sort
                    dense
                    v-bind:id="`header-table`"
                    v-scrollsync="`main-table`"></v-data-table>
        </div>
        <v-data-table
                :headers="headers"
                :items="scoreCards"
                hide-actions
                ref="dataTable"
                class="division-table"
                dense
                v-bind:id="`main-table`"
                v-scrollsync="`header-table`"
        >
            <template slot="items" slot-scope="props">
                <td>{{props.item.place}}</td>
                <td>
                    <span class="player" v-for="(player, p) in props.item.players" v-bind:key="p">
                        <router-link :to="{name: 'playerStats', params:playerRouteParams(player)}">{{ player.player.name | shortName }}</router-link>
                    </span>
                </td>
                <td v-for="(hole,h) in props.item.holes" v-bind:key="h" valign="middle" class="text-xs-center" v-bind:class="getHoleClass(hole)">{{hole.score}}</td>
                <td><strong>{{props.item.total}} ({{props.item.from_par}})</strong></td>
                <td><em>{{props.item.points}}</em></td>
                <td><em>{{props.item.players_beat}}</em></td>
                <td><em>{{props.item.winner ? 'Yes' : ''}}</em></td>
                <td><em>{{props.item.cashed}}</em></td>
            </template>
        </v-data-table>
    </section>
</v-flex>
</template>

<script>
  import VueSticky from 'vue-sticky';
  import WeekList from './shared/WeekSelector';

  export default {
    name: "WeekScoreCard",
    props: ['seasonId', 'seasonName', 'week'],
    components: {
      WeekList
    },
    directives: {
      'sticky': VueSticky
    },
    data() {
      return {
        loading: false,
        scoreCards: null,
        error: null,
        stickyConfig: {
          zIndex: 1,
          stickyTop: 64,
          disabled: false
        },
        headers: [ ],
        // scoreCardsTable: [],
        // tableHeaders: []
      }
    },
    methods: {
      async fetchData() {
        this.error = null;
        this.scoreCards = [];
        this.loading = true;
        try {
          const results = await Promise.all([
            this.$apiClient.seasons(this.seasonId),
            this.$apiClient.weeks(this.seasonId, this.week === 'bye' ? '0' : this.week)
          ]);

          this.season = results[0].data;
          this.scoreCards = results[1].data.cards;

          this.headers = [
            { text: 'Place', value: 'total.place', align: 'left', width: 35, sortable: false },
            { text: 'Name', value: 'player.name', align: 'left', sortable: false, class:'player-name' },
            ...this.scoreCards[0].holes.map((h, i) => ({ text: h.hole, value: `hole[${i}].score`, align: 'center', width: 30, sortable: false })),
            { text: 'Score', value: 'total.score', align: 'left', width: 75, sortable: false },
            { text: 'Points', value: 'total.points', align: 'left', width: 50, sortable: false },
            { text: '#Beat', value: 'total.players_beat', align: 'left', width: 60, sortable: false },
            { text: 'Win', value: 'winner', align: 'left', width: 50, sortable: false },
            { text: 'Cashed', value: 'cashed', align: 'left', width: 50, sortable: false },
          ];

        } catch (e) {
          this.error = e;
        }

        this.loading = false;
      },
      adjustOffset() {
        this.stickyConfig.stickyTop = ['xs', 'sm'].indexOf(this.$vuetify.breakpoint.name) > -1 ?  48 : 64;
      },
      playerRouteParams(playerEntry) {
        return {
          seasonId: this.season.season_id,
          seasonName: this.season.name.replace(/\s/g, '-'),
          playerId: playerEntry.player.player_id,
          playerName: playerEntry.player.name.replace(/\s/g,'-')
        };
      },
      getHoleClass(hole) {
        const score = parseInt(hole.score);

        if (score === 1) {
          return 'ace';
        }

        const diff = score - (hole.par || 3);

        if (diff >= 3) {
          return 'triple-bogey';
        }

        if (diff <= -3) {
          return 'albatross';
        }

        switch (diff) {
          case -2: return 'eagle';
          case -1: return 'birdie';
          case 0: return 'par';
          case 1: return 'bogey';
          case 2: return 'double-bogey';
        }
      }
    },
    watch: {
      '$route': 'fetchData',
      '$vuetify.breakpoint' : 'adjustOffset'
    },
    created() {
      this.fetchData();
      this.adjustOffset();
    }
  }
</script>

<style>
.player-name {
    min-width: 150px !important;
}
.week-hole-score {
    max-width: 30px !important;
}
.week-hole-score-total {
    max-width: 50px;
}
</style>
